import { useEffect } from "react";
import SingleGridItem from "./SingleGridItem";
import { useDispatch, useSelector} from "react-redux"
import { fetchPosts } from "../../redux/features/posts/postsSlice";

export default function PostsGrid() {
    const dispatch = useDispatch();
    const {sortBy, filterBy} = useSelector(state=>state.filters)
    const { posts, isLoading, isError, error } = useSelector(
        (state) => state.posts
    );

    useEffect(() => {
        dispatch(fetchPosts({sortBy,filterBy}));
    }, [dispatch, filterBy, sortBy]);

    // decide what to render
    let content;

    if (isLoading) content = "Loading";
    if (!isLoading && isError)
        content = <div>{error}</div>;

    if (!isError && !isLoading && posts?.length === 0) {
        content = <div>No Posts found!</div>;
    }

    if (!isError && !isLoading && posts?.length > 0) {
        content = posts.map((post) => (
            <SingleGridItem key={post.id} post={post} />
        ));
    }

    return (
        <main className="post-container" id="lws-postContainer">
            {content}
        </main>
    )
};